"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyCodes = void 0;
exports.KeyCodes = {
    ALT: 'Alt',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_UP: 'ArrowUp',
    CONTROL: 'Control',
    ENTER: 'Enter',
    ESCAPE: 'Escape',
    SHIFT: 'Shift',
    SPACE: ' ', // Spacebar
    TAB: 'Tab',
    HOME: 'Home',
    PAGE_UP: 'PageUp',
    END: 'End',
    PAGE_DOWN: 'PageDown',
};
